import React from "react";
import MainTemplate from "../../components/MainTemplate/MainTemplate";
import CardBackground from "../../components/MainTemplate/CardBackground";
import MyProfileUpdateChild from "./MyProfileUpdateChild";

const MyProfileUpdate = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <MyProfileUpdateChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default MyProfileUpdate;
